import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ToggleSection from 'zoomforth_component_lib/toggle_section.jsx';


class NotificationsToggleSection extends Component {
  render() {
    const maybeAtAddress = this.props.emailAddress ? (' at ' + this.props.emailAddress) : '';

    return (
      <ToggleSection
        name="Email Notifications"
        tooltip="If enabled, you will receive email notifications when someone visits your site."
        explanation={
          !this.props.checked ? null :
          'You will be emailed' + maybeAtAddress + ' when this link is visited.' 
        }
        checked={this.props.checked} 
        onChange={this.props.onChange} />
    );
  }
}

NotificationsToggleSection.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  emailAddress: PropTypes.string
};

export default NotificationsToggleSection;
